import { convertToDefaultDateHourFormat } from "@/util"

export const CBR_ACC = {
  ID: 'id',
  USERNAME: 'username',
  BUDGET: 'budget',
  SLOTS_LOADING_STATUS: 'slots_loading_status',
  SLOTS_EXPORT_TIME: 'slots_export_time',
  COURSE_LOCATIONS: 'cities',
  FOR_EXTENDED_EXAMS: 'for_extended_exams',
  FOR_RESERVATION_SYSTEM: 'for_reservation_system',
  CURRENTLY_RESERVED_STUDENTS: 'currently_reserved_students',
  MAX_RESERVED_STUDENTS: 'max_reserved_students'
}

export default class CbrAccModel {
  constructor(item = {}) {
    this.ID = item[CBR_ACC.ID]
    this.username = item[CBR_ACC.USERNAME]
    this.budget = item[CBR_ACC.BUDGET]
    this.slotsLoadingStatus = item[CBR_ACC.SLOTS_LOADING_STATUS]
    this.slotsExportTime = item[CBR_ACC.SLOTS_EXPORT_TIME]
    this.courseLocations = item[CBR_ACC.COURSE_LOCATIONS]
    this.forExtendedExams = item[CBR_ACC.FOR_EXTENDED_EXAMS]
    this.products = item.products
    this.forReservationSystem = item[CBR_ACC.FOR_RESERVATION_SYSTEM]
    this.reservedStudents = item[CBR_ACC.CURRENTLY_RESERVED_STUDENTS]
    this.maxReservedStudents = item[CBR_ACC.MAX_RESERVED_STUDENTS]

    this.apiAttributes = {
      [CBR_ACC.ID]: 'id',
      [CBR_ACC.USERNAME]: 'username',
      [CBR_ACC.BUDGET]: 'budget',
      [CBR_ACC.SLOTS_LOADING_STATUS]: 'slotsLoadingStatus',
      [CBR_ACC.SLOTS_EXPORT_TIME]: 'slotsExportTime',
      [CBR_ACC.COURSE_LOCATIONS]: 'courseLocations',
      [CBR_ACC.FOR_EXTENDED_EXAMS]: 'forExtendedExams',
      [CBR_ACC.FOR_RESERVATION_SYSTEM]:'forReservationSystem',
      [CBR_ACC.CURRENTLY_RESERVED_STUDENTS]: 'reservedStudents',
      [CBR_ACC.MAX_RESERVED_STUDENTS]: 'maxReservedStudents'
    }
    this.animation = false
  }

  merge(msg) {
    this.slotsLoadingStatus = msg[CBR_ACC.SLOTS_LOADING_STATUS] 
    this.slotsExportTime = msg[CBR_ACC.SLOTS_EXPORT_TIME]
    this.budget = msg[CBR_ACC.BUDGET]
    this.username = msg[CBR_ACC.USERNAME]
    this.courseLocations = msg[CBR_ACC.COURSE_LOCATIONS]
    this.forExtendedExams = msg[CBR_ACC.FOR_EXTENDED_EXAMS]
    this.forReservationSystem = msg[CBR_ACC.FOR_RESERVATION_SYSTEM]

    // this.updated()
  }

  mergeProducts(products) {
    this.products = products
  }

  get formattedSlotsExportTime() {
    return convertToDefaultDateHourFormat(this.slotsExportTime)
  }

  // updated() {
  //   this.animation = true
  //   setTimeout(() => {
  //     this.animation = false
  //   }, 1000);
  // }
}